import { render, staticRenderFns } from "./stockPurchasingReport.vue?vue&type=template&id=652793ea&"
import script from "./stockPurchasingReport.vue?vue&type=script&lang=js&"
export * from "./stockPurchasingReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports